import { get } from "@/services/axiosUitils";
import {
  UserDetailsByIdResponse,
  UserDetailsResponse,
} from "@/utils/types/UserManagement/UserManagement";

const base = "/user-details/";

class UserManagementService {
  listUsers = async (
    page: number,
    pageSize: number,
    filters?: {
      search?: string;
      is_profile_completed?: boolean;
    }
  ): Promise<UserDetailsResponse> => {
    const params: Record<string, string | number | boolean> = {
      page,
      page_size: pageSize,
    };
    const search = filters?.search?.trim();
    if (search) {
      params.search = search;
    }
    if (filters?.is_profile_completed !== undefined) {
      params.is_profile_completed = filters.is_profile_completed;
    }
    return await get<UserDetailsResponse>(base, { params });
  };

  getUserDetailsById = async (id: string): Promise<UserDetailsByIdResponse> => {
    return await get<UserDetailsByIdResponse>(`${base}${id}/`);
  };
}

export default new UserManagementService();
